export default "__VITE_ASSET__Cz6LBvkR__"